import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Listing } from "../../lib/types"
import Page from "../../components/page/page"
import { useInventoryContext } from "../../hooks/use-inventory"
import { ChevronLeft, LoaderIcon } from "lucide-react"
import { useListingContext } from "../../hooks/use-listings"

export const ListingPage = () => {
  const { listingId } = useParams()
  const { inventory } = useInventoryContext()
  const { listings } = useListingContext()
  const navigate = useNavigate()
  const [listing, setListing] = useState<Listing>()

  useEffect(() => {
    const l = listings.find((item) => item.id === listingId)
    if (l) {
      setListing(l)
    }
  }, [listings, listingId])

  return (
    <>
      {listing ? <Page title={<div className="flex items-center justify-start gap-3">
        <div onClick={() => navigate(-1)}>
          <ChevronLeft stroke="#000" width={24} height={24} />
        </div>
        {listing.title}
      </div>}
      >
        <div>
          <div className="p-3">listing {listingId}</div>
        </div>
      </Page>
        : <LoaderIcon />}
    </>
  )
}
